import React from 'react'
import PropTypes from 'prop-types'
import { InputGroupAddon, SVGIcon } from 'components/qstrap'

const Icon = (props) => {
  if (props.name) {
    return (
      <InputGroupAddon className="icon-bg-transparent icon-tag">
        <SVGIcon name={props.name} />
      </InputGroupAddon>
    )
  }

  return null
}

Icon.propTypes = {
  name: PropTypes.string,
}

export default Icon
